module.exports = __webpack_public_path__ + "media/images/recruit/common/icon-facebook-df008cf50acb4ca7320769466f79406c.svg";